import { Navigate } from "react-router-dom";
import { AuthContext } from "../../shared/contexts";
import { useContext } from "react";

export const LogoutPage = () => {
  const authContext = useContext(AuthContext);
  authContext.logout();
  return <Navigate to="/login" />;
}
